
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-f6d18cce\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./envoiBulletins.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./envoiBulletins.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f6d18cce\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./envoiBulletins.vue.html"),
  /* scopeId */
  "data-v-f6d18cce",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Primobox/envoiBulletins/envoiBulletins.vue.html
// module id = zNyg
// module chunks = 2